import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import Table from 'components/Table';
import Pagination from 'components/Pagination';
import { onEditRow } from 'utils/table';
import { applySearch, applyFilter } from 'utils';
import { PAGINATION } from 'helper/const';
import ROUTES from 'routes';
import { getClientColumns, getIsDefaultSearchFilter } from './utils';
import { DEFAULT_SORT, DEFAULT_ALL_FILTERS } from './constants';
import NotFound from './NotFound';
import FilterActions from './FilterActions';
import { useArchivedClientsTabData } from './selectorData';
import classes from './ClientList.module.scss';

let allFilters = { ...DEFAULT_ALL_FILTERS };

const ArchiveClientsTab = props => {
  const history = useHistory();
  const { handleGetArchivedClients, keyword, setKeyword, activeTab } = props;
  const {
    archivedClientsLoading,
    archivedClients,
    archivedClientsTotal,
    archivedClientsIsMore,
  } = useArchivedClientsTabData();
  const [sort, setSort] = useState(DEFAULT_SORT);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDefaultFilter, setIsDefaultFilter] = useState(true);
  const handleView = record => {
    history.push(ROUTES.CLIENT_DETAIL({ id: record.id }));
  };
  const columns = getClientColumns(handleView);
  const isNotFound =
    getIsDefaultSearchFilter({ keyword, sort, isDefaultFilter }) &&
    archivedClientsTotal === 0 &&
    archivedClients.length === 0 &&
    !archivedClientsLoading;
  const handleAllFilterChange = (name, value) => {
    allFilters = {
      ...allFilters,
      [name]: value,
    };
    const applyFn = name === 'city' ? applySearch : applyFilter;
    applyFn(value, () => {
      handleGetArchivedClients(1, DEFAULT_SORT, keyword, allFilters);
      setCurrentPage(1);
      setIsDefaultFilter(isEqual(allFilters, DEFAULT_ALL_FILTERS));
    });
  };
  const filterActionProps = {
    keyword,
    setKeyword,
    onSearch: val => {
      handleGetArchivedClients(1, sort, val, allFilters);
      setCurrentPage(1);
    },
    selectedRows,
    handleAllFilterChange,
    isDefaultFilter,
    hideButtons: true,
  };

  useEffect(() => {
    allFilters = { ...DEFAULT_ALL_FILTERS };
    if (activeTab === 2) {
      handleGetArchivedClients(1, DEFAULT_SORT, keyword, allFilters);
      setCurrentPage(1);
      setSort(DEFAULT_SORT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  return (
    <div
      className={cn(classes.mainContentTab, {
        [classes.isNotFound]: isNotFound,
      })}
    >
      {isNotFound ? (
        <NotFound
          onClick={() => {}}
          isArchived
          title="No clients have been archived yet. "
        />
      ) : (
        <>
          <FilterActions {...filterActionProps} />
          <Table
            rowSelection={{
              selectedRowKeys,
              onChange: (sRowKeys, sRows) => {
                setSelectedRowKeys(sRowKeys);
                setSelectedRows(sRows);
              },
            }}
            columns={columns}
            data={archivedClients.map((client, index) => ({
              ...client,
              idIndex: `${client.id}_${index}`,
            }))}
            rowKey="idIndex"
            loading={archivedClientsLoading}
            rowIsClick
            isScroll
            scroll={{ x: 850 }}
            onRow={record => {
              return {
                onClick: event => {
                  onEditRow(event, () => {
                    handleView(record);
                  });
                },
              };
            }}
            showSorterTooltip={false}
            onSortChange={sorter => {
              const newSort = {
                field: sorter.field,
                order: sorter.order,
              };
              setSort(newSort);
              handleGetArchivedClients(
                currentPage,
                newSort,
                keyword,
                allFilters
              );
            }}
            locale={{
              emptyText: `No clients found`,
            }}
          />
          {archivedClientsIsMore && (
            <Pagination
              current={currentPage}
              pageSize={PAGINATION.PER_PAGE}
              total={archivedClientsTotal}
              right
              onChange={page => {
                setCurrentPage(page);
                handleGetArchivedClients(page, sort, keyword, allFilters);
              }}
              className={classes.pagination}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ArchiveClientsTab;
